document.addEventListener('click', function(e) {
  const addBtn = e.target.closest('[data-suggested-add]');
  if (!addBtn) return;

  const variantId = addBtn.dataset.variantId;
  const isInDrawer = addBtn.closest('#CartDrawer') !== null;
  
  addBtn.disabled = true;
  addBtn.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(response => response.json())
  .then(() => {
    if (isInDrawer) {
      $(document.body).trigger('added.ajaxProduct');
    } else {
      window.location.reload();
    }
    setTimeout(function() {
      addBtn.disabled = false;
      addBtn.textContent = 'Add';
    }, 500);
  })
  .catch(() => {
    addBtn.disabled = false;
    addBtn.textContent = 'Add';
  });
});